
/* eslint-disable camelcase */

// Containers should include all logic that enhances a component
// this includes any reduce methods, recompose, or middleware.

import { compose, withHandlers } from 'recompose'
import { parseNumber, formatNumber } from 'libphonenumber-js'
import moment from 'moment'

export default compose(
  withHandlers({
    parsePhoneNumber: () => (phone) => {
      if (!phone) return ''
      const parsed = parseNumber(phone, 'US')
      return parsed && parsed.phone ? parsed.phone : phone
    },
    formatPhoneNumber: () => (phone) => {
      if (!phone) return ''
      return formatNumber(phone, 'US', 'National')
    },
    formatCurrency: () => (value, precision = 2) => {
      const preciseValue = parseFloat(value).toFixed(precision)
      if (isNaN(preciseValue)) {
        return value
      }
      const currency = preciseValue ? preciseValue.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') : ''
      return `$${currency}`
    },
    formatExtLink: () => (url) => {
      const protocolCheck = /^(http(s)?:)?\/\//
      const defaultProtocal = 'http://'
      return protocolCheck.test(url) ? url : defaultProtocal.concat(url)
    },
    formattedTime: () => (time) => moment.utc(time).local().format('h:mm a'),
    isJson: () => (data) => {
      try {
        return JSON.parse(data)
      } catch (e) {
        return data
      }
    },
    formatLocation: () => ({ city, state, zipcode }) => {
      return `${city ? `${city},` : ''}${state ? `${state}` : ''}${zipcode ? `${zipcode}` : ''}`
    },
    formatFullTitle: () => ({ first_name, last_name, middle_name, name_suffix, medical_suffix }) => {
      let fullTitle = first_name || ''

      if (middle_name) {
        fullTitle += ` ${middle_name}`
      }

      if (last_name) {
        fullTitle += ` ${last_name}`
      }

      if (name_suffix) {
        fullTitle = `${fullTitle}, ${name_suffix}`
      }

      if (medical_suffix) {
        fullTitle = `${fullTitle}, ${medical_suffix}`
      }

      return fullTitle
    }
  })
)
